import { useEffect, useState, useRef } from "react";
import { UploadIcon } from "asset/icons";

const FileUpload = ({
    label = "Drag or Upload file here",
    initialFileName = "",
    onFileSelect,
    disabled = false,
    accept = "image/png, image/jpeg, application/pdf",
    maxSize = 5 * 1024 * 1024,
    validationError = "",
}) => {
    const [fileName, setFileName] = useState(initialFileName);
    const [error, setError] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        setFileName(initialFileName || "");
    }, [initialFileName]);

    const validateAndUpload = (file) => {
        if (!file) return;

        if (file.size > maxSize) {
            setError("File size exceeds 5MB.");
            setFileName("");
            onFileSelect(null);
            return;
        }

        setFileName(file.name);
        setError("");
        onFileSelect(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        validateAndUpload(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        validateAndUpload(file);
    };

    return (
        <div
            className={`w-full bg-[#f1f5f9] rounded-xl border border-dashed border-[#D0D5DD] min-h-[140px] flex flex-col justify-center items-center gap-2 cursor-pointer transition-all duration-200 ${
                disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
            } ${(error || validationError) && "!border-[#F04438] !bg-[#FFF1F3]"}`}
            onClick={() => !disabled && fileInputRef.current.click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
        >
            <div className="flex flex-col justify-center items-center gap-2">
                <div className="bg-[#E9D7FE] p-3 rounded-full flex items-center justify-center">
                    <UploadIcon className="size-6 *:stroke-[#7F56D9]" />
                </div>
                <p className="text-sm font-medium text-[#344054]">{fileName || label}</p>
                <p className="text-xs text-[#667085]">JPEG, PNG, JPG, PDF · 5 MB max.</p>
            </div>

            <input
                type="file"
                ref={fileInputRef}
                className="hidden"
                accept={accept}
                onChange={handleFileChange}
                disabled={disabled}
            />

            {error && <p className="text-xs text-red-600 mt-2">{error}</p>}
            {!error && validationError && (
                <p className="mt-2 text-xs text-[#D92D20]">{validationError}</p>
            )}
        </div>
    );
};

export default FileUpload;
